export default "__VITE_ASSET__Db9Y4mFA__"